<template>
  <div class="w-100">
    <div class=" p-list-representation-wrapper align-items-start">
      <Loader class="w-100" :loading="loading">
        <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
          <div class="w-100" >
            <appHeader></appHeader>
          </div>

          <div class=" row p-list-representation-data w-100" :key="updateForm">
            <contentList
            @closeModalEntry="closeModalEntry"
            @submitData="submitData"
            @selectedCity="selectedCity"
            @selectedProvince="selectedProvince"

            :form-data="formData"
            :citys="citys"
            :city-selected     ="citySelected"
            :province-selected ="provinceSelected"
            :province-items="provinceItems"
            :excel-data="excelData"
            :status-show-modal-entry-pay="statusShowModalEntryPay"
            :name-family-salondar="nameFamilySalondar"
            :selected-name-family-salondar="selectedNameFamilySalondar"

            :all-enums="allEnums"

            ></contentList>
          </div>

        </div>
      </Loader>

    </div>


  </div>
</template>

<script>
import contentList from '../components/editEntrySalon/contentList';
import appHeader from '../components/includes/AppHeader';



export default {
  name: "editEntrySalon",
  components: {
    contentList,
    appHeader,
  },

  props: {

  },

  data() {
    return {
      loading       : true,
      excelData     : [
        {
          family         : 'محمد صالح معافی',
          city           : 'قم',
          representation : 'استان',
          phone          : '09198814783',
        },
      ],
      citys                                   : [

      ],
      provinceItems                           : [

      ],
      citySelected      : {

      },
      provinceSelected  : {

      },
      statusShowModalEntryPay     : false,
      excelData                   : [
        {
          family         : 'محمد صالح معافی',
          city           : 'قم',
          representation : 'استان',
          phone          : '09198814783',
        },
      ],
      nameFamilySalondar  : [
        {
          id    : 0,
          title : 'محمد معافی',
          phone : '091988817654',
        },
        {
          id    : 1,
          title : 'مهدی دادور',
          phone : '091063696547',
        },
      ],
      selectedNameFamilySalondar  :{
        id    : 0,
        title : 'محمد معافی',
        phone : '091988817654',
      },
      formData  : {
        "id": -1,
        "club_id": '',
        "address": "",
        "name": "",
        "facilities": [
        ],
        "using_type": [
        ],
        "ball_type": [
        ],
        "content": "",
        "phone": "",
        "sans_price": '',
        "sans_beyane_price": '',
        "system_porsant": '',
        "balls_count": '',
        "shaba_code": "",
        "lat": '',
        "lng": '',
        "status": "",
        "bank_name" : '',
        "contract_image"          : {},
        "ownership_or_rent_image" : '',
      },
      updateForm  : 0,
      allEnums    : {},

    }
  },

  watch: {
    formData(){
      this.getProvinceAndCity();
      this.getSetDefault();
      this.getEnums();
      this.updateForm++;
    },
  },

  created() {

  },

  mounted() {
    const getParams = this.$route.params.id;

    if (typeof(getParams) != 'undefined') {
      this.formData.id   = getParams;
      const  singleData = JSON.parse(localStorage.getItem('hallSingle'));
      this.formData     = singleData;
    }
    else {
      delete this.formData.id;
    }

  },


  methods: {
    paganationChangePage(data){
      console.log(data,'paganationChangePage');
    },

    submitTransaction(){

    },

    editRepresentation(){

    },

    modalShowEntryPay(){
      this.statusShowModalEntryPay = true;
    },

    closeModalEntry(status){
      if (!status) {
        this.statusShowModalEntryPay = false;
      }
    },

    getSetDefault(){
      const formData = this.formData;

    },

    getEnums(){
      this.$store
      .dispatch('hall/getEnums', {

      })
      .then((res)=>{
        this.loading  = false;
        this.allEnums = res.data;
      })
    },

    submitData(data){
      this.formData = data;
      this.loading  = true;


      this.$store
      .dispatch('hall/editEntryHall', {
        data : {
          ...this.formData
        }
      })
      .then((res)=>{
        this.loading  = false;
        if (res.is_successful) {
          // localStorage.setItem("hallSingle", JSON.stringify(res.data));
          this.$message.success(res.message);
          this.$router.push({name:'listSalonsOwner' , params:{id:res.data.club_id} })
        }
        else {
          this.$message.error(res.message)
        }
      })
    },


    selectedCity(data){

      if (data.id != -1) {
        this.citySelected   = data
        this.formData.city_id = data.id;
      }


    },

    selectedProvince(data){

      if (this.checkEmptyCity != 'firstCheckSelectedCity') {
        this.citySelected  = {name:'انتخاب کنید',id:-1};
      }

      if (data.id != -1) {
        this.provinceSelected = data;
        this.formData.province_id =  data.id;
        this.updateCitySelected++;
        this.citys               = data.city;
        this.checkEmptyCity = 'eventUpdate';
      }


    },

    getDefaultProvinceAndCity(dataProvinceAndCity){
      let getProvince           = [];
      let getCity               = [];
      const cityIdDefault       =  this.formData.club.city_id;
      const provinceIdDefault   =  this.formData.club.province_id;

      dataProvinceAndCity.data.map((t)=>{
        getProvince = [...getProvince,t];

        if (provinceIdDefault == t.id ) {
          this.provinceSelected  = t;
        }

        t.city.map((contentCity)=>{
          if (cityIdDefault == contentCity.id ) {
            this.citySelected  = contentCity;
          }
          getCity               = [...getCity,contentCity];
        })
      })

      this.citys               = getCity;
      this.provinceItems       = getProvince;
      this.checkEmptyCity = 'firstCheckSelectedCity';
    },

    findProvinceAndCityTable(tableData){
      tableData.map((contentTable)=>{
        // add cama in amount value //
        const resultAddCama       = addCama(contentTable.sans_price);
        contentTable.addCamaPrice = resultAddCama

        this.provinceItems.map((t)=>{
          if (t.id == contentTable.province_id) {
            contentTable.findProvinceOfAllProvinces = t;
            t.city.map((contentCity)=>{
              if (contentCity.id == contentTable.city_id) {
                contentTable.findCityOfAllCitys = contentCity;
              }
            })
          }
        })
      })
    },

    getProvinceAndCity(){
      this.$store
      .dispatch('hall/getProvinceAndCity', {
      })
      .then((res)=>{
        this.getDefaultProvinceAndCity(res);
      })
    },



  }


}
</script>
